var _style, _linearGradient, _path, _linearGradient2, _path2, _defs, _clipPath, _g, _defs2, _clipPath2, _linearGradient3, _path3, _g2, _g3, _g4, _g5, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleAnalytics = function SvgGoogleAnalytics(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Analytics",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.1 152",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .googleanalyticssvg0{fill:url(#SVGID_1_googleanalytics)}.googleanalyticssvg1{fill:url(#SVGID_2_googleanalytics)}.st2googleanalytics{clip-path:url(#SVGID_4_googleanalytics)}.st3googleanalytics{fill:#f57c00}.st4googleanalytics{fill:#ffc107}.st5googleanalytics{clip-path:url(#SVGID_6_googleanalytics);fill:url(#SVGID_7_googleanalytics)}.st6googleanalytics,.st7googleanalytics,.st8googleanalytics,.st9googleanalytics{opacity:.2;clip-path:url(#SVGID_9_googleanalytics);fill:#fff;enable-background:new}.st7googleanalytics,.st8googleanalytics,.st9googleanalytics{clip-path:url(#SVGID_11_googleanalytics)}.st8googleanalytics,.st9googleanalytics{clip-path:url(#SVGID_13_googleanalytics)}.st9googleanalytics{clip-path:url(#SVGID_15_googleanalytics);fill:#bf360c}.googleanalyticssvg10{fill:url(#SVGID_16_googleanalytics)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_googleanalytics",
    gradientUnits: "userSpaceOnUse",
    y1: 77.32,
    x2: 152.1,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "googleanalyticssvg0",
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_googleanalytics",
    gradientUnits: "userSpaceOnUse",
    y1: 77.32,
    x2: 152.1,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "googleanalyticssvg1",
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_googleanalytics",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2googleanalytics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V152h39.7c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4googleanalytics",
    d: "M48 60v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h88V48H60c-6.6 0-12 5.4-12 12z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_googleanalytics",
    overflow: "visible"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_googleanalytics",
    gradientUnits: "userSpaceOnUse",
    x1: 74.25,
    y1: 79.07,
    x2: 148.36,
    y2: 4.96,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0.02
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5googleanalytics",
    d: "M100 48v104h39.7c6.7 0 12.2-5.5 12.2-12.2V100L100 48z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_googleanalytics",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6googleanalytics",
    d: "M60 49h40v-1H60c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_googleanalytics",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7googleanalytics",
    d: "M12 101h36v-1H12c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_googleanalytics",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2v1c0-6.7 5.5-12.2 12.2-12.2h27.5c6.7 0 12.2 5.5 12.2 12.2v-1C152 5.5 146.5 0 139.8 0z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_googleanalytics",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_googleanalytics"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_googleanalytics",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9googleanalytics",
    d: "M139.8 151H12c-6.6 0-12-5.4-12-12v1c0 6.6 5.4 12 12 12h127.7c6.7 0 12.2-5.5 12.2-12.2v-1c.1 6.7-5.4 12.2-12.1 12.2z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_googleanalytics",
    gradientUnits: "userSpaceOnUse",
    x1: 50.969,
    y1: 102.289,
    x2: 149.295,
    y2: 3.963,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "googleanalyticssvg10",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google-analytics.652df736cd10384950a12012785266cf.svg";